import { FilmTile } from "@components/film/FilmTile"
import { BrowseFilmTileFragment, FilmSessionFragment, TffProgramFragment } from "@generated-types"
import { useMemo } from "react"
import dayjs, { Dayjs } from "dayjs"
import { formatDateUri, formatNiceDate } from "@utils/date-format"

type Props = {
  program: TffProgramFragment
}

export function TFFProgram(props: Props) {
  const sessionsByDate = useMemo(() => {
    const map = new Map<
      string,
      {
        key: string
        date: Dayjs
        sessions: {
          date: Dayjs
          film: BrowseFilmTileFragment
          session: FilmSessionFragment
        }[]
      }
    >()

    for (const film of props.program.films ?? []) {
      for (const session of film?.sessions ?? []) {
        const date = dayjs(session?.info?.dateTime)
        const dateString = formatDateUri(date)
        if (!map.has(dateString)) {
          map.set(dateString, {
            key: dateString,
            date: date,
            sessions: [],
          })
        }
        map.get(dateString)?.sessions.push({
          date,
          session: session!,
          film: film!,
        })
      }
    }

    map.forEach((row) => {
      row.sessions.sort((a, b) => a.date.diff(b.date))
    })

    return [...map.values()].sort((a, b) => {
      return a.date.diff(b.date)
    })
  }, [props.program])

  return (
    <div className="flex flex-col gap-6 pt-6">
      {sessionsByDate.map((row) => {
        return (
          <div key={row.key}>
            <h3 className="w-grid mx-auto type-title-m">{dayjs(row.date).format("ddd D MMMM")}</h3>
            <div className="grid-auto pt-5 gap-y-6">
              {row.sessions.map((item) => {
                return (
                  <div key={item.session.id} className="col-span-12 md:col-span-4 lg:col-span-3">
                    <FilmTile film={item.film} session={item.session} allowMobile />
                  </div>
                )
              })}
            </div>
          </div>
        )
      })}
    </div>
  )
}
